// The two View Planning tabs — each lands on its saved-plans list and drills
// into a read-only mirror of the flow that created the plan.
export const VIEW_PLANNING_TAB = Object.freeze({
  REDEPLOYMENT: "redeployment",
  WORKFORCE: "workforce",
});
